import { Button, Dialog, DialogTitle, DialogContent, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, DialogActions } from '@material-ui/core';
import { HistoryOutlined } from '@material-ui/icons';
import moment from 'moment';
import React from 'react';
import { ILog } from '../../types/Logger';
import { useAuth } from '../../hooks/auth';
import TableRowCollapse from '../TableRowCollapse';

type Props = React.ComponentProps<typeof Button> & {
    logs: ILog[];
}

function Logger(props: Props) {

    const { data } = useAuth();

    const [dialog, setDialog] = React.useState<boolean>(false);

    return (
        <React.Fragment>
            <Button
                color="default"
                variant="contained"
                startIcon={<HistoryOutlined />}
                onClick={() => setDialog(true)}
                {...props}>
                Logs
            </Button>
            <Dialog open={dialog} fullWidth maxWidth="sm" onClose={() => setDialog(false)}>
                <DialogTitle>Logs</DialogTitle>
                <DialogContent>
                    <TableContainer>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Usuário</TableCell>
                                    <TableCell>Descrição</TableCell>
                                    {(data.user.papel === 4 || data.user.papel === 3 || data.user.papel === 5) &&
                                        <TableCell>Detalhes</TableCell>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.logs && props.logs.map((log, index) =>
                                    <TableRowCollapse
                                        key={index}
                                        stringData={log.detalhes}
                                        visible={data.user.papel === 4 || data.user.papel === 3 || data.user.papel === 5}>
                                        <TableCell>{moment(log.created_at).format('DD/MM/YYYY HH:mm')}</TableCell>
                                        <TableCell>{log.user_name}</TableCell>
                                        <TableCell>{log.msg}</TableCell>
                                    </TableRowCollapse>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialog(false)} color="primary">
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

export default Logger;